module.exports = __webpack_public_path__ + "static/media/PianoScore3-KELsMUSIC.0fdec728.jpg";